import React from "react";

export default function TestimonialsSection() {
  return <span style={{ display: "none" }}></span>;
}

// export default function Example() {
//   return (
//     <div className="relative mt-0 md:mt-10 mb-10 md:mb-20 px-5 md:px-0">
//       <div className="lg:mx-auto lg:max-w-7xl lg:px-8 bg-secondary-700 text-center py-10 md:py-20 rounded-2xl">
//         <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
//           Not sure of right marketing platform?
//         </h2>
//         <p className="mt-4 text-lg leading-6 text-white">
//           Consult our e-commerce experts now. We would love to explore ways to
//           increase your sales.
//         </p>
//         <div className="w-full mt-8 sm:max-w-lg sm:mx-auto sm:text-center md:text-center">
//           <form action="#" method="POST" className="mt-3 sm:flex">
//             <label htmlFor="email" className="sr-only">
//               Email
//             </label>
//             <input
//               type="text"
//               name="email"
//               id="email"
//               className="block w-full py-3 text-base rounded-md pl-4 placeholder-gray-500 shadow-sm focus:ring-secondary focus:border-secondary-800 sm:flex-1 "
//               placeholder="Enter your email"
//             />
//             <button
//               type="submit"
//               className="mt-3 w-full px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary shadow-sm hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2
//                         focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto"
//             >
//               Get Started{" "}
//             </button>
//           </form>
//           <p className="mt-2 text-sm text-white text-center md:text-left">
//             Take one month free trial. No credit card required.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }
